// @ vendors
const Immutable = require('immutable');

// @ constants
const actionTypes = require('../../insuranceConstants/actionTypes');

const setInitialState = () => {
    return Immutable.Map().merge({
        insuranceModifyIsFetching: false,
        insuranceIsBeingModified: false,
        insuranceHasBeenModified: false,
        modifyRequestError: '',
    });
};

const insuranceRequestModify = (state = setInitialState(), action) => {
    switch (action.type) {
        case actionTypes.INSURANCE_REQUEST_RELATED_MODIFY_INSURANCE_REQUEST:
            const { isModifying, hasBeenModified } = action.data;
            return state.merge({
                insuranceIsBeingModified: isModifying,
                insuranceModifyIsFetching: isModifying,
                insuranceHasBeenModified: hasBeenModified
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_MODIFY_INSURANCE_SUCCESS:
            return state.merge({
                insuranceIsBeingModified: true,
                insuranceModifyIsFetching: false
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_MODIFY_INSURANCE_FAILURE:
            return state.merge({
                modifyRequestError: action.data.error,
                insuranceModifyIsFetching: false
            });

        default:
            return state;
    }
};

module.exports = insuranceRequestModify;
